// import React, { createContext, useState, useContext, useEffect } from 'react';
// // یک Context Provider برای مدیریت وضعیت سایدبار در برنامه است. 
// // این کامپوننت به کامپوننت‌های دیگر اجازه می‌دهد که وضعیت باز/بسته بودن سایدبار را کنترل کنند.

// // Create a context for managing the sidebar state
// const SidebarContext = createContext();

// // Create a SidebarProvider to wrap the app
// const SidebarProvider = ({ children }) => {
//     const [isSidebarOpen, setIsSidebarOpen] = useState(false);

//     const toggleSidebar = () => {
//         setIsSidebarOpen((prev) => !prev);
//     };

//     // Side effect to set sidebar size when it's open based on screen size
//     useEffect(() => {
//         const screenWidth = window.innerWidth;

//         if (isSidebarOpen) {
//             // If the screen is 'lg' size, toggle to 'sm'
//             if (screenWidth >= 992) {
//                 document.body.setAttribute('data-sidebar-size', 'sm');
//             }
//             // If the screen is 'sm' size, add the 'sidebar-enable' class
//             else {
//                 document.body.classList.add('sidebar-enable');
//             }
//         } else {
//             // If the screen is 'sm' size, remove the 'sidebar-enable' class
//             if (screenWidth < 992) {
//                 document.body.classList.remove('sidebar-enable');
//             } else {
//                 // On closing for larger screens, reset to 'lg' size
//                 document.body.setAttribute('data-sidebar-size', 'lg');
//             }
//         }
//     }, [isSidebarOpen]);
//     // وقتی سایدبار باز می‌شود:
//     // برای صفحه‌های بزرگ (>= 992px)، data-sidebar-size='sm' اضافه می‌شود.
//     // برای صفحه‌های کوچک (< 992px)، کلاس sidebar-enable به body اضافه می‌شود.
//     // وقتی سایدبار بسته می‌شود:
//     // برای صفحه‌های کوچک (< 992px)، sidebar-enable حذف می‌شود.
//     // برای صفحه‌های بزرگ (>= 992px)، data-sidebar-size='lg' تنظیم می‌شود.
//     // ✅ این کار باعث می‌شود سایدبار در اندازه‌های مختلف ریسپانسیو باشد.
//     return (
//         <SidebarContext.Provider value={{ isSidebarOpen, toggleSidebar }}>
//             {children}
//         </SidebarContext.Provider>
//     );
// };
// // مقدار باز/بسته بودن سایدبار و تابع toggleSidebar را در Context ذخیره می‌کند.
// // همه کامپوننت‌های فرزند (children) می‌توانند این مقدار را دریافت کنند
// // Hook to use the sidebar state in other components
// const useSidebar = () => useContext(SidebarContext);

// export { SidebarProvider, useSidebar };

// import React, { createContext, useState, useContext, useEffect } from 'react';

// const SidebarContext = createContext();

// const SidebarProvider = ({ children }) => {
//     const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 992);

//     const toggleSidebar = () => {
//         setIsSidebarOpen((prev) => !prev);
//     };

//     useEffect(() => {
//         const handleResize = () => {
//             if (window.innerWidth < 992) {
//                 setIsSidebarOpen(false);
//                 document.body.classList.remove('sidebar-enable');
//                 document.body.removeAttribute('data-sidebar-size');
//             } else {
//                 setIsSidebarOpen(true);
//             }
//         };

//         window.addEventListener('resize', handleResize);
//         handleResize();

//         return () => {
//             window.removeEventListener('resize', handleResize);
//         };
//     }, []);

//     useEffect(() => {
//         if (isSidebarOpen) {
//             if (window.innerWidth >= 992) {
//                 document.body.setAttribute('data-sidebar-size', 'sm');
//             } else {
//                 document.body.classList.add('sidebar-enable');
//             }
//         } else {
//             if (window.innerWidth >= 992) {
//                 document.body.setAttribute('data-sidebar-size', 'collapsed'); // مخفی کردن متن‌ها در سایز بزرگ
//             } else {
//                 document.body.removeAttribute('data-sidebar-size');
//                 document.body.classList.remove('sidebar-enable');
//             }
//         }
//     }, [isSidebarOpen]);

//     return (
//         <SidebarContext.Provider value={{ isSidebarOpen, toggleSidebar }}>
//             {children}
//         </SidebarContext.Provider>
//     );
// };

// const useSidebar = () => useContext(SidebarContext);

// export { SidebarProvider, useSidebar };
// import React, { createContext, useState, useContext, useEffect } from 'react';
// import './Sidebar.css'; // فایل CSS را وارد کنید

// const SidebarContext = createContext();

// const SidebarProvider = ({ children }) => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 992);
// console.log(isSidebarOpen,"isSidebarOpen")
//   const toggleSidebar = () => {
//     setIsSidebarOpen((prev) => !prev);
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth < 992) {
//         setIsSidebarOpen(false);
//         document.body.classList.remove('sidebar-enable');
//         document.body.removeAttribute('data-sidebar-size');
//       } else {
//         setIsSidebarOpen(true);
//         document.body.classList.remove('sidebar-enable');
//       }
//     };

//     window.addEventListener('resize', handleResize);
//     handleResize();

//     return () => {
//       window.removeEventListener('resize', handleResize);
//     };
//   }, []);

//   useEffect(() => {
//     if (isSidebarOpen) {
//       if (window.innerWidth >= 992) {
//         document.body.setAttribute('data-sidebar-size', 'sm');
//       } else {
//         document.body.classList.add('sidebar-enable');
//       }
//     } else {
//       if (window.innerWidth >= 992) {
//         document.body.setAttribute('data-sidebar-size', 'collapsed');
//       } else {
//         document.body.removeAttribute('data-sidebar-size');
//         document.body.classList.remove('sidebar-enable');
//       }
//     }
//   }, [isSidebarOpen]);

//   return (
//     <SidebarContext.Provider value={{ isSidebarOpen, toggleSidebar }}>
//       {children}
//     </SidebarContext.Provider>
//   );
// };

// const useSidebar = () => useContext(SidebarContext);

// export { SidebarProvider, useSidebar };
// import React, { createContext, useState, useContext, useEffect } from 'react';

// const SidebarContext = createContext();

// const SidebarProvider = ({ children }) => {
//     const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 992);

//     const toggleSidebar = () => {
//         setIsSidebarOpen((prev) => !prev);
//     };

//     useEffect(() => {
//         const handleResize = () => {
//             if (window.innerWidth < 992) {
//                 setIsSidebarOpen(false);
//                 document.body.classList.remove('sidebar-enable');
//                 document.body.removeAttribute('data-sidebar-size');
//             } else {
//                 setIsSidebarOpen(true);
//                 document.body.classList.remove('sidebar-enable');
//             }
//         };

//         window.addEventListener('resize', handleResize);
//         handleResize();

//         return () => {
//             window.removeEventListener('resize', handleResize);
//         };
//     }, []);

//     useEffect(() => {
//         if (isSidebarOpen) {
//             if (window.innerWidth >= 992) {
//                 document.body.setAttribute('data-sidebar-size', 'sm');
//                 document.body.classList.remove('sidebar-collapsed');
//             } else {
//                 document.body.classList.add('sidebar-enable');
//             }
//         } else if(!isSidebarOpen) {
//             if (window.innerWidth >= 992) {
//                 document.body.setAttribute('data-sidebar-size', 'collapsed');
//                 document.body.classList.add('sidebar-collapsed');
//             } else {
//                 document.body.removeAttribute('data-sidebar-size');
//                 document.body.classList.remove('sidebar-enable');
//             }
//         }
//     }, [isSidebarOpen]);

//     return (
//         <SidebarContext.Provider value={{ isSidebarOpen, toggleSidebar }}>
//             {children}
//         </SidebarContext.Provider>
//     );
// };

// const useSidebar = () => useContext(SidebarContext);

// export { SidebarProvider, useSidebar };
import React, { createContext, useState, useContext, useEffect } from 'react';

// ایجاد یک context برای مدیریت وضعیت سایدبار
const SidebarContext = createContext();

// SidebarProvider که وضعیت سایدبار را مدیریت می‌کند
const SidebarProvider = ({ children }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    // تابع برای تغییر وضعیت سایدبار (باز/بسته)
    const toggleSidebar = () => {
        setIsSidebarOpen((prev) => !prev);
    };

    // Effect برای مدیریت کلاس‌ها و نمایش سایدبار بر اساس اندازه صفحه
    useEffect(() => {
        const screenWidth = window.innerWidth;
        const updateSidebarClass = () => {
            if (isSidebarOpen) {
                // اگر صفحه بزرگ‌تر از 992px باشد، کلاس 'sidebar-open' به body اضافه می‌شود
                if (screenWidth >= 1140) {
                    document.body.removeAttribute('data-sidebar-size', 'lg');
                    document.body.classList.remove('sidebar-enable');
                    document.body.classList.add('sidebar-open');
                    document.body.classList.remove('sidebar-closed');
                    
                }
                // اگر صفحه کوچک‌تر از 992px باشد، کلاس 'sidebar-enable' به body اضافه می‌شود
                else {
                    document.body.classList.add('sidebar-enable');

                }
            } else {
                // اگر سایدبار بسته باشد:
                if (screenWidth >= 1140) {
                    document.body.removeAttribute('data-sidebar-size', 'lg');
                    document.body.classList.remove('sidebar-open');
                    document.body.classList.add('sidebar-closed');
                    document.body.classList.add('sidebar-enable');
                } else {
                    document.body.classList.remove('sidebar-enable');
                }
            }
        }
        updateSidebarClass();

        // تنظیم یک listener برای تغییر اندازه صفحه
        const handleResize = () => {
            updateSidebarClass();
        };

        window.addEventListener('resize', handleResize);

        // پاک کردن listener در صورت unmount شدن کامپوننت
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isSidebarOpen]);

    return (
        <SidebarContext.Provider value={{ isSidebarOpen, toggleSidebar }}>
            {children}
        </SidebarContext.Provider>
    );
};

// Hook برای دسترسی به وضعیت سایدبار در سایر کامپوننت‌ها
const useSidebar = () => useContext(SidebarContext);

export { SidebarProvider, useSidebar };
